import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { Form, Input, Button } from "semantic-ui-react";
import { createContext } from "../../actions/fs";

/**
 * Import wizard-specific stylesheets
 */
import "./Wizard.css";
import OrganizerFileIcon from "../organizer/view/OrganizerFileIcon";
import FileTypes from "../editor/FileTypes";

/**
 * NewContextWizard : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Wizard which allows the user to create a new context
 * from scratch
 */
class NewContextWizard extends Component {
  state = {
    /**
     * Entered name for the new context
     */
    contextName: "",
    /**
     * True if the continue button is enabled
     */
    isContinueButtonEnabled: false,
    /**
     * True if the wizard is currently processing an action
     */
    isLoading: false
  };

  /**
   * enteredNameUpdated: (event, sender) => ()
   * Fired when the user-entered values for the new context
   * name has changed
   */
  enteredNameUpdated = (_, { value }) => {
    this.setState({
      contextName: value,
      isContinueButtonEnabled: this.isAllowedContextName(value)
    });
  };

  /**
   * finishCreation: ()
   * Dispatches the creation of a new wizard and finishes
   * the wizard.
   */
  finishCreation = () => {
    if (!this.isAllowedContextName(this.state.contextName)) return;

    this.setState({
      isLoading: true
    });

    const reference = this;
    const context = {
      displayName: this.state.contextName.trim()
    };

    this.props.createContext(context, () => {
      reference.setState({ isLoading: false }, () => {
        reference.props.history.push("/organizer");
      });
    });
  };

  /**
   * isAllowedContextName: name => Boolean
   * Returns true if the provided context name is allowed
   */
  isAllowedContextName = name => {
    if (!name) return false;
    return name.trim() !== "";
  };

  render() {
    return (
      <div className="wz-content">
        <h1>
          <OrganizerFileIcon documentType={FileTypes.Context} size={48} />
          <FormattedMessage
            id="wizard.create.context.title"
            description="Title for new context creation wizard"
          />
        </h1>
        <p>
          <FormattedMessage
            id="wizard.create.context.description"
            description="Short summary for new context creation wizard"
          />
        </p>
        <div className="wz-field">
          <Form>
            <Input
              placeholder={this.props.intl.formatMessage({
                id: "wizard.create.context.fieldName.placeholder"
              })}
              value={this.state.contextName}
              onChange={this.enteredNameUpdated}
            />
          </Form>
        </div>
        <Button
          color="blue"
          disabled={!this.state.isContinueButtonEnabled}
          loading={this.state.isLoading}
          onClick={this.finishCreation}
        >
          <FormattedMessage
            id="wizard.create.context.create"
            description="Action button text to create new context"
          />
        </Button>
      </div>
    );
  }
}

NewContextWizard.propTypes = {
  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired,
  /**
   * Dispatchable actions connected to this component
   */
  createContext: PropTypes.func.isRequired,
  /**
   * History object provided through withRouter
   */
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default connect(
  null,
  { createContext }
)(injectIntl(withRouter(NewContextWizard)));



// WEBPACK FOOTER //
// ./src/modules/wizard/NewContextWizard.js